import React from 'react';
import AssessmentScoreResultContent from '../components/AssessmentScoreResultContent';

// 学生综合测评汇总页面
// 页面结构：条件筛选卡片 + 结果卡片（计算总成绩/导出按钮 + 统计提示 + 成绩表格 + 详情抽屉）
export default function ComprehensiveAssessmentSummaryPage() {
  return (
    <AssessmentScoreResultContent mode="summary" />
  );
}
